import { render, staticRenderFns } from "./MyUploadPlus.vue?vue&type=template&id=6ef67052&"
import script from "./MyUploadPlus.vue?vue&type=script&lang=js&"
export * from "./MyUploadPlus.vue?vue&type=script&lang=js&"
import style0 from "./MyUploadPlus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports